import { downloadPlanInfoFiles } from "../repositories/participant";

export async function viewPlanningCenterDocument(
  planId: number,
  empId: number,
  extension: string,
  resourceId: number,
  role: string
): Promise<String> {
  return downloadPlanInfoFiles(
    `/plans/${planId}/employees/${empId}/viewPlanningCenterDocument`,
    {
      role,
      extension,
      resourceId,
    }
  );
}
